import { Practitioner } from 'src/models';
import { Avatar, AvatarProps } from 'antd';
import { generateColorFromName, getPractitionerName } from 'src/utils';
import { NonOptional } from '@insight-health-ai/roseate/utils';

type PractitionerNameProps = {
  practitioner: NonOptional<Partial<Practitioner>, 'first_name' | 'last_name'>;
  avatar?: Pick<AvatarProps, 'size' | 'icon'> | false;
  showName?: boolean;
};

export const PractitionerName = ({
  practitioner,
  avatar = { size: 24 },
  showName = true,
}: PractitionerNameProps) => {
  const { first_name, last_name } = practitioner;

  const name = getPractitionerName(practitioner) || '';
  const nameParts = [first_name, last_name];
  const initials = nameParts
    .map((part) => part?.[0])
    .join('')
    .toUpperCase();
  return (
    <div className="flex items-center gap-2">
      {avatar && (
        <Avatar
          style={{
            flexShrink: 0,
            color: 'white',
            backgroundColor: generateColorFromName(name),
          }}
          {...(typeof avatar === 'object' ? avatar : {})}
        >
          {initials}
        </Avatar>
      )}
      {showName && <span>{name}</span>}
    </div>
  );
};
